import React from "react";
import { renderContentWithLineBreaks } from "../utils/renderContentWithLineBreaks";

interface SectionProps {
  heading?: string;
  content?: string; // Make content optional
  bgColorClass?: string;
  headingClassName?: string;
  contentClassName?: string;
  className?: string;
  imageSrc?: string;
  imageAlt?: string;
  imageClassName?: string;
}

const Section: React.FC<SectionProps> = ({
  heading = "",
  content = "",
  bgColorClass = "bg-[#AE582D]",
  headingClassName = "text-3xl font-bold text-white mb-6 text-center",
  contentClassName = "max-w-md text-lg text-white mb-4 text-center md:text-left",
  className = "",
  imageSrc,
  imageAlt = "",
  imageClassName = "w-full h-full object-cover shadow rounded-xl", // <-- changed here
}) => (
  <div
    className={`flex flex-col items-center ${bgColorClass} ${
      imageSrc
        ? "h-full shadow-lg rounded-xl" // No padding if image
        : "py-8 px-4 sm:py-10 sm:px-10 lg:px-10 h-full shadow-lg rounded-xl"
    } ${className}`}
  >
    {imageSrc ? (
      <div className="flex-1 h-full w-full flex items-stretch">
        <img
          src={imageSrc}
          alt={imageAlt}
          className={imageClassName}
        />
      </div>
    ) : (
      <>
        <h2 className={headingClassName}>{heading}</h2>
        <div className={contentClassName}>
          <p>{renderContentWithLineBreaks(content)}</p>
        </div>
      </>
    )}
  </div>
);

export default Section;